"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var ShareOnline = function (_a) {
    var toggleShareableLink = _a.toggleShareableLink, isSending = _a.isSending;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: "/ShareOnline.svg", alt: "Share online", height: 64, width: 64 }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mb: 2, mt: 3 }, { children: "Share Online" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mb: 4, textAlign: "center" }, { children: "Create a static version of this report accessible through a unique web link. Anyone with this link on the internet can view the report." })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ fullWidth: true, size: "large", onClick: function () { return toggleShareableLink(true); }, isSending: isSending }, { children: "Create Shareable Web Link" }))] }));
};
exports.default = ShareOnline;
